module.exports = __webpack_public_path__ + "static/media/lady-carrying-laundry-new.5b474fcd.jpg";